import { render, staticRenderFns } from "./SessionsListHeader.vue?vue&type=template&id=63b4e96e&scoped=true&"
import script from "./SessionsListHeader.vue?vue&type=script&lang=js&"
export * from "./SessionsListHeader.vue?vue&type=script&lang=js&"
import style0 from "./SessionsListHeader.vue?vue&type=style&index=0&id=63b4e96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4e96e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VRow,VTooltip})
